/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { InlineObject } from '../model/models';
import { InlineObject1 } from '../model/models';
import { PropertyResource } from '../model/models';
import { PropertyStatusRequest } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface PropertyStatusServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Update status
     * 
     * @param property The property ID
     * @param propertyStatusRequest 
     */
    updatePropertyStatus(property: number, propertyStatusRequest: PropertyStatusRequest, extraHttpRequestParams?: any): Observable<PropertyResource>;

}
